var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSphere(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8745 20C10.8745 14.9442 14.9903 10.8457 20.0673 10.8457C22.8214 10.8457 25.2896 12.0475 26.9794 13.9646C28.2317 15.3853 30.4036 15.5261 31.8302 14.279C33.2569 13.0319 33.3983 10.8693 32.1459 9.44857C29.2061 6.11361 24.8826 4 20.0673 4C11.1936 4 4 11.1635 4 20C4 28.8365 11.1936 36 20.0673 36C24.8826 36 29.2061 33.8864 32.1459 30.5515C33.3983 29.1308 33.2569 26.968 31.8302 25.721C30.4036 24.4739 28.2317 24.6147 26.9794 26.0353C25.2896 27.9525 22.8214 29.1543 20.0673 29.1543C14.9903 29.1543 10.8745 25.0558 10.8745 20Z",
    fill: "url(#paint0_linear_13213_60845)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6875 16.5C29.7545 16.5 28.1875 18.0671 28.1875 20.0005C28.1875 21.9338 29.7545 23.5 31.6875 23.5C33.6205 23.5 35.1875 21.9338 35.1875 20.0005C35.1875 18.0671 33.6205 16.5 31.6875 16.5Z",
    fill: "#FF9857"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13213_60845",
    x1: 29.4919,
    y1: 4,
    x2: 1.14196,
    y2: 33.2278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA15E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6636"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSphere);
export default __webpack_public_path__ + "static/media/sphere.16c87f59ffd2b9d3764e3c55af353dd3.svg";
export { ForwardRef as ReactComponent };